import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d522e08"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "home_div",
  class: "home_div"
}
const _hoisted_2 = {
  key: 1,
  class: "sticky_div"
}
const _hoisted_3 = { class: "home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_google_login = _resolveComponent("google-login")!
  const _component_search = _resolveComponent("search")!
  const _component_advert = _resolveComponent("advert")!
  const _component_banner = _resolveComponent("banner")!
  const _component_icon_design = _resolveComponent("icon-design")!
  const _component_flash_sale = _resolveComponent("flash-sale")!
  const _component_hot_categories = _resolveComponent("hot-categories")!
  const _component_product_list = _resolveComponent("product-list")!
  const _component_tabbar = _resolveComponent("tabbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$setup.isByteApp)
      ? (_openBlock(), _createBlock(_component_google_login, { key: 0 }))
      : _createCommentVNode("", true),
    ($setup.search_title !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_search, { title: $setup.search_title }, null, 8, ["title"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.home_datas, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          (item.floor_name === 'adv_item')
            ? (_openBlock(), _createBlock(_component_advert, {
                key: 0,
                url: item.image,
                type: item.type,
                data: item.data
              }, null, 8, ["url", "type", "data"]))
            : _createCommentVNode("", true),
          (item.floor_name === 'adv_list')
            ? (_openBlock(), _createBlock(_component_banner, {
                key: 1,
                show_time: item.show_time,
                url_list: item.item
              }, null, 8, ["show_time", "url_list"]))
            : _createCommentVNode("", true),
          (item.floor_name === 'icon_list')
            ? (_openBlock(), _createBlock(_component_icon_design, {
                key: 2,
                iconList: item.item
              }, null, 8, ["iconList"]))
            : _createCommentVNode("", true),
          (item.floor_name === 'flash_sale')
            ? (_openBlock(), _createBlock(_component_flash_sale, { key: 3 }))
            : _createCommentVNode("", true),
          (item.floor_name === 'hot_categories')
            ? (_openBlock(), _createBlock(_component_hot_categories, { key: 4 }))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createVNode(_component_product_list),
      _createVNode(_component_tabbar, { active: $setup.tabbar_index }, null, 8, ["active"])
    ])
  ], 512))
}